import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsGrid } from './components/StatsGrid';
import { ServicesSection } from './components/ServicesSection';
import { PricesSection } from './components/PricesSection';
import { StationsSection } from './components/StationsSection';
import { OrderSection } from './components/OrderSection';
import { Footer } from './components/Footer';
import { Sun, Moon, Menu, X } from 'lucide-react';
const navItems = [{
  label: 'Nosotros',
  id: 'nosotros'
}, {
  label: 'Servicios',
  id: 'servicios'
}, {
  label: 'Precios',
  id: 'precios'
}, {
  label: 'Estaciones',
  id: 'estaciones'
}, {
  label: 'Contacto',
  id: 'contacto'
}];
export function App() {
  const [theme, setTheme] = useState<'light' | 'dark'>('light');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null;
    const initialTheme = savedTheme || 'light';
    setTheme(initialTheme);
    document.documentElement.setAttribute('data-theme', initialTheme);
    if (initialTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  const scrollToSection = (id: string) => {
    setMobileMenuOpen(false);
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  return <div className="min-h-screen font-sans selection:bg-[#FCEE02] selection:text-[#251F1F] transition-colors duration-300 bg-[var(--bg-primary)]" data-id="element-0">
      {/* NAVBAR */}
      <nav className="fixed top-0 left-0 w-full z-50 backdrop-blur-md border-b-2 border-[#FCEE02] shadow-lg transition-colors duration-300" style={{
      backgroundColor: 'var(--bg-nav)'
    }} data-id="element-1">
        <div className="container mx-auto px-4 sm:px-6 md:px-12 h-20 sm:h-28 flex items-center justify-between" data-id="element-2">
          <div className="flex items-center" data-id="element-3">
            <img src="https://static.wixstatic.com/media/5c887f_28ae1fb14c394d49bbb1a23fcfe4001d~mv2.png/v1/crop/x_0,y_668,w_3162,h_1825/fill/w_421,h_205,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/5c887f_28ae1fb14c394d49bbb1a23fcfe4001d~mv2.png" alt="Junquito Gas Logo" className={`h-14 sm:h-20 md:h-28 object-contain drop-shadow-md ${theme === 'light' ? 'mix-blend-multiply' : 'brightness-125 contrast-125'}`} data-id="element-4" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-5">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-sm font-bold uppercase tracking-widest hover:text-[#FCEE02] transition-colors relative group px-4 py-2 border-2 border-transparent hover:border-[#FCEE02] rounded-lg" style={{
            color: 'var(--text-primary)'
          }} data-id="element-6">
                {item.label}
              </button>)}
          </div>

          <div className="flex items-center gap-2 sm:gap-4" data-id="element-7">
            <button onClick={toggleTheme} className="p-2 rounded-full hover:bg-black/5 transition-colors" aria-label="Toggle theme" data-id="element-8">
              {theme === 'light' ? <Moon className="w-5 h-5 sm:w-6 sm:h-6 text-gray-700" data-id="element-9" /> : <Sun className="w-5 h-5 sm:w-6 sm:h-6 text-[#FCEE02]" data-id="element-10" />}
            </button>

            <button onClick={() => scrollToSection('solicitar')} className="hidden md:block px-6 lg:px-8 py-3 bg-[#EC2424] text-white font-bold uppercase text-sm tracking-wider hover:bg-[#FB900D] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 border-2 border-[#EC2424] hover:border-[#FB900D] rounded-lg" data-id="element-11">
              Solicitar
            </button>

            {/* Mobile Hamburger */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 rounded-lg transition-colors" style={{
            color: 'var(--text-primary)'
          }} aria-label="Toggle menu" data-id="element-12">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-13" /> : <Menu className="w-6 h-6" data-id="element-14" />}
            </button>
          </div>
        </div>
      </nav>

      {/* MOBILE MENU OVERLAY */}
      <div className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} data-id="element-15">
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setMobileMenuOpen(false)} data-id="element-16" />

        {/* Menu Panel */}
        <div className="absolute top-20 sm:top-28 right-0 w-full sm:w-80 h-[calc(100vh-5rem)] sm:h-[calc(100vh-7rem)] border-l-2 border-[#FCEE02] overflow-y-auto transition-transform duration-300 sm:rounded-bl-2xl" style={{
        backgroundColor: 'var(--bg-primary)',
        transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(100%)'
      }} data-id="element-17">
          <div className="p-6 space-y-2" data-id="element-18">
            {navItems.map((item, index) => <button key={item.id} onClick={() => scrollToSection(item.id)} className="w-full text-left px-4 py-4 font-bold uppercase tracking-widest text-base border-b transition-all duration-200 hover:pl-6 hover:text-[#FCEE02] rounded-lg" style={{
            color: 'var(--text-primary)',
            borderColor: 'var(--border-color)',
            opacity: mobileMenuOpen ? 1 : 0,
            transform: mobileMenuOpen ? 'translateX(0)' : 'translateX(20px)',
            transition: `all 0.3s ease ${index * 0.05 + 0.1}s`
          }} data-id="element-19">
                {item.label}
              </button>)}

            <button onClick={() => scrollToSection('solicitar')} className="w-full mt-6 px-6 py-4 bg-[#EC2424] text-white font-black uppercase tracking-wider hover:bg-[#FB900D] transition-colors text-center border-2 border-[#EC2424] hover:border-[#FB900D] rounded-xl" style={{
            opacity: mobileMenuOpen ? 1 : 0,
            transition: 'all 0.3s ease 0.4s'
          }} data-id="element-20">
              Solicitar Servicio
            </button>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <main className="pt-20 sm:pt-28" data-id="element-21">
        <section id="nosotros" data-id="element-22">
          <HeroSection data-id="element-23" />
        </section>

        <StatsGrid data-id="element-24" />

        <section id="servicios" data-id="element-25">
          <ServicesSection data-id="element-26" />
        </section>

        <section id="precios" data-id="element-27">
          <PricesSection data-id="element-28" />
        </section>

        <section id="estaciones" data-id="element-29">
          <StationsSection data-id="element-30" />
        </section>

        <section id="solicitar" data-id="element-31">
          <OrderSection data-id="element-32" />
        </section>
      </main>

      <footer id="contacto" data-id="element-33">
        <Footer data-id="element-34" />
      </footer>
    </div>;
}